// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21qzR","question":"styles_question__kMiyt","description":"styles_description__3wbUU"};